import { Route } from "react-router-dom";

import Login from "./login";

const loginRoute = <Route path="/login" element={<Login />} />;

export default loginRoute;
